import {
	GET_NANO_CARRIER_DETAILS,
	GET_NANO_CARRIER_DETAILS_SUCCESS,
	GET_NANO_CARRIER_DETAILS_FAIL,
	GET_NANO_CARRIER_DETAILS_RESET,
} from '../actions/getNanoCarrierDetailsAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getNanoCarrierDetailsReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_NANO_CARRIER_DETAILS:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_NANO_CARRIER_DETAILS_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_NANO_CARRIER_DETAILS_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_NANO_CARRIER_DETAILS_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getNanoCarrierDetailsReducer;
